<div class="task-list-grid">
  <div class="task-list-grid-header">
    <h3>{{ 'VALUE Task(s)' | translate: { value: tasks?.length || 0 } }}</h3>
  </div>
  <rotec-default-grid-v2
    [selectConfig]="false"
    [darkMode]="true"
    [filterPanel]="true"
    [searchInput]="true"
    [filterButton]="false"
    [columns]="columns"
    [data]="searchState"
    (stateChange)="search($event)"
    (fulltextSearchChanged)="search({ fulltext: $event })"
    (rowClick)="_openTask($event.id)"
  >
    <ng-template rotecGridCellV2="title" let-dataItem="dataItem">{{ dataItem.title }}</ng-template>
    <ng-template rotecGridCellV2="scheduling" let-dataItem="dataItem">{{
      dataItem.scheduling | taskInterval
    }}</ng-template>
    <ng-template rotecGridCellV2="responsible" let-dataItem="dataItem">
      {{ dataItem.responsible }}
    </ng-template>
    <ng-template rotecGridCellV2="actions" let-dataItem="dataItem">
      @if (userRightsService.hasActionRights$(actions.updateTask) | async) {
        <rotec-icon-v2
          svgIcon="edit"
          class="edit-icon"
          (click)="_openTask(dataItem.id, $event)"
        ></rotec-icon-v2>
      }
      @if (userRightsService.hasActionRights$(actions.deleteTask) | async) {
        <rotec-icon-v2 svgIcon="trash" (click)="_deleteTask($event, dataItem.id)"></rotec-icon-v2>
      }
    </ng-template>
  </rotec-default-grid-v2>
</div>
